import React, { useRef, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { Row } from "reactstrap";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { GoogleLogin } from "react-google-login";
import { LoginRegister } from "../LoginRegister";
import { loginApi } from "../../../api";
import { setToken } from "../../../redux";
import { Alert } from "../../../shared";
import { withRouter } from "react-router-dom";
import i18n from "../../../i18n/locales/config";
import { useTranslation } from "react-i18next";

const LoginComp = (props) => {
  const { t } = useTranslation();
  const [showHome, setShowHome] = useState(false);
  useEffect(() => {
    if (Cookies.get("token")) {
      setShowHome(false);
      props.history.push("/panel");
    } else {
      setShowHome(true);
    }
  }, []);

  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });
  const dispatch = useDispatch();

  const clientId =
    "329703603574-m25trgmnld1lobprk0rphnvimcdf5070.apps.googleusercontent.com";
  const form = useRef(null);

  const initialLoginValues = {
    email: "",
    password: "",
  };

  const submitLoginForm = () => {
    const data = new FormData(form.current);
    loginApi(data)
      .then((res) => {
        dispatch(setToken(res.data.data.token));
        Cookies.set("token", res.data.data.token);
        props.history.push("/panel");
      })
      .catch(() => {
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          question: false,
          message: t("نام کاربری و یا رمز عبور شما اشتباه است"),
          type: "Error",
        }));
        setTimeout(() => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: false,
          }));
        }, 2000);

      });
  };

  const validationSchemaLogin = Yup.object({
    email: Yup.string()
      .required(t("ایمیل را وارد کنید"))
      .email(t("ایمیل را طبق فرمت وارد کنید")),
    password: Yup.string().required(t("رمز عبور را وارد کنید.")),
  });

  const onSuccess = (res) => {
    // console.log("yeeeeeees" + res);
  };

  const onFailure = (res) => {
    // console.log("nooooo" + res);
  };

  const goToForgotPassword = () => {
    props.history.push("/forgotpassword");
  };

  return (
    <>
      {showHome && (
        <LoginRegister>
          <div className="px-4 pt-5">
            <Row className="justify-content-center flex-column mb-5">
              <h6>{t("ورود")}</h6>
              <p className="fn12">{t("دسترسی به حساب")}</p>
            </Row>
            <Row className="justify-content-center flex-column">
              <Formik
                initialValues={initialLoginValues}
                onSubmit={submitLoginForm}
                validationSchema={validationSchemaLogin}
              >
                {(props) => (
                  <Form ref={form}>
                    <div className="mb-3">
                      <div className="inputs d-flex flex-column justify-content-center w-100 p-1">
                        {props.values.email && (
                          <p className="fn12 m-0">{t("ایمیل")}</p>
                        )}
                        <input
                          type="email"
                          placeholder={t("ایمیل")}
                          name="email"
                          className="w-100 fn12"
                          onChange={props.handleChange}
                          onBlur={props.handleBlur}
                        />
                      </div>
                      <ErrorMessage name="email">
                        {(errMsg) => (
                          <div className="text-danger fn10 mt-1">{errMsg}</div>
                        )}
                      </ErrorMessage>
                    </div>
                    <div className="mb-3">
                      <div className="inputs d-flex flex-column justify-content-center w-100 p-1">
                        {props.values.password && (
                          <p className="fn12 m-0">{t("رمز عبور")}</p>
                        )}
                        <input
                          type="password"
                          name="password"
                          placeholder={t("رمز عبور")}
                          onChange={props.handleChange}
                          onBlur={props.handleBlur}
                          className="w-100 fn12"
                        />
                      </div>
                      <ErrorMessage name="password">
                        {(errMsg) => (
                          <div className="text-danger fn10 mt-1">{errMsg}</div>
                        )}
                      </ErrorMessage>
                    </div>
                    <a className="fn12" onClick={goToForgotPassword}>
                      {t("رمز عبور خود را فراموش کردید؟")}
                    </a>
                    <button
                      type="submit"
                      className="btn btn-primary formBtn mt-4"
                    >
                      {t("ورود")}
                    </button>
                  </Form>
                )}
              </Formik>
            </Row>
            <hr className="bg-white" />
            <div id="login-gmail">
              {/* <button className="btn btn-light bg-light-form formBtn">gmail</button> */}
              <GoogleLogin
                clientId={clientId}
                // buttonText={'login'}
                onSuccess={onSuccess}
                onFailure={onFailure}
                style={{ width: "100%" }}
                isSignedIn={true}
              />
              <div className="fn12 mt-4 text-center">
                <a onClick={() => props.history.push("/register")}>
                  {t("حساب کاربری ندارید؟ ثبت نام کنید!")}
                </a>
              </div>
            </div>
          </div>
          {showAlert.show && (
            <Alert message={showAlert.message} type={showAlert.type} />
          )}
        </LoginRegister>
      )}
    </>
  );
};

const Login = withRouter(LoginComp);

export { Login };
